import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { map, Observable, of, delay, tap } from 'rxjs';
import { environment } from '../../../environments/environment';


export interface AnnouncementResponse {
  announcementId: number;
  userId: number;
  title: string;
  message: string;
  // pending API field
  announcementType: 'info' | 'warning' | 'danger' | 'success'; 
  startDate: string;
  endDate: string;
  createdDate: string;
  createdBy: number;
  modifiedDate: string | null;
  modifiedBy: number | null;
}

@Injectable({
  providedIn: 'root',
})
export class AnnouncementService {
  private http = inject(HttpClient);
  private platformId = inject(PLATFORM_ID);
  private baseUrl = `${environment.dashApiUrl}/api/Announcement`;

  getAllAnnouncements(): Observable<AnnouncementResponse | undefined> {
    if (!isPlatformBrowser(this.platformId)) return of(undefined);
    const now = new Date();
    //console.log('announcement request');
  return this.http.get<AnnouncementResponse[]>(`${this.baseUrl}/all`)
    .pipe(
      map(announcements => announcements.find(a => 
        new Date(a.startDate) <= now && new Date(a.endDate) >= now
      ))
      //tap(result => console.log('result:', result))
    );
  //TODO: swap api to use /published endpoint and only show type === 'External'
  }
}
